import { Input } from "antd";
import styles from "./index.module.less";
import ArrowIcon from "@/assets/imgs/arrow_right.svg";
import { useRef, useState } from "react";
import classNames from "classnames";
import { useClickAway } from "ahooks";
import { options, Option } from "./options";

const CitySelector = ({
  value = [],
  onChange,
}: {
  value?: string[];
  onChange?: (value: string[]) => void;
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<any>(null);
  const ref1 = useRef<any>(null);
  useClickAway(() => {
    setOpen(false);
  }, [ref, ref1]);
  const [selectedProvince, setSelectedProvince] = useState<string | null>(
    options[0].label
  );
  const [cityOptions, setCityOptions] = useState<Option[]>([]);

  return (
    <div className={styles.citySelector}>
      <div
        className={styles.cityInput}
        onClick={() => setOpen(true)}
        ref={ref1}
      >
        <Input
          placeholder="请输入您的城市"
          className={styles.input}
          readOnly
          value={value.join("/")}
        />
        <div className={styles.cityIcon}>
          <img src={ArrowIcon} />
        </div>
      </div>
      <div
        className={classNames(styles.cityDropdown, { [styles.open]: open })}
        ref={ref}
      >
        <div className={styles.options}>
          <div className={styles.optionsInner}>
            {options.map((option) => (
              <div
                key={option.value}
                className={classNames(styles.option, {
                  [styles.selectedOption]: selectedProvince === option.label,
                })}
                onMouseEnter={() => {
                  setSelectedProvince(option.label);
                  setCityOptions(option.children || []);
                }}
              >
                <div className={styles.optionLabel}>{option.label}</div>
                {option.children && (
                  <div className={styles.arrow}>
                    <img src={ArrowIcon} />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={styles.subOptions}>
            {cityOptions.map((option) => (
              <div
                key={option.value}
                className={classNames(styles.option, {
                  // [styles.selectedOption]: value[1] === option.label,
                })}
                onClick={() => {
                  if (!selectedProvince) return;
                  onChange?.([selectedProvince, option.label]);
                  setOpen(false);
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CitySelector;
